import {createAction, props} from '@ngrx/store';
import {
    SupportCategoryModel,
    SupportTicketMessageRequest,
    SupportTicketMobileMessageModel,
    SupportTicketMobileModel,
    SupportTicketRequest,
    SupportTicketsMobileModel
} from '../_models/support.models';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {PageableResponse} from '@common/models/commonHTTP.models';
import {CabinetType} from '@common/models/cabinet.models';

export const LoadCategories = createAction(
    '[Support] Load Categories',
    props<{ categoryType: 'TENANT_WEB' | 'MANAGER' | 'COMPANY' }>()
);

export const LoadCategoriesSuccess = createAction(
    '[Support] Load Categories Success',
    props<{ payload: { response: SupportCategoryModel[] } }>()
);

export const LoadCategoriesFailure = createAction(
    '[Support] Load Categories Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);

export const LoadTickets = createAction(
    '[Support] Load Tickets',
    props<{ payload: { loading?: DahLoadingType } }>()
);

export const LoadTicketsSuccess = createAction(
    '[Support] Load Tickets Success',
    props<{ payload: { response: SupportTicketsMobileModel } }>()
);

export const LoadTicketsFailure = createAction(
    '[Support] Load Tickets Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const LoadArchiveTickets = createAction(
    '[Support] Load Archive Tickets'
);

export const LoadArchiveTicketsSuccess = createAction(
    '[Support] Load Archive Tickets Success',
    props<{payload: {response: PageableResponse<SupportTicketMobileModel>}}>()
);

export const LoadArchiveTicketsFailure = createAction(
    '[Support] Load Archive Tickets Failure',
    props<{payload: {error: HttpErrorResponse}}>()
);


export const LoadMessages = createAction(
    '[Support] Load Messages',
    props<{ payload: { ticketId: string, clearState?: boolean } }>()
);

export const LoadMessagesSuccess = createAction(
    '[Support] Load Messages Success',
    props<{ payload: { response: PageableResponse<SupportTicketMobileMessageModel>, ticketId: string, clearState?: boolean } }>()
);

export const LoadMessagesFailure = createAction(
    '[Support] Load Messages Failure',
    props<{ payload: { error: HttpErrorResponse, ticketId: string } }>()
);


export const LoadLastMessage = createAction(
    '[Support] Load Last Message',
    props<{ payload: { ticketId: string } }>()
);

export const LoadLastMessageSuccess = createAction(
    '[Support] Load Last Message Success',
    props<{ payload: { ticketId: string, message: SupportTicketMobileMessageModel } }>()
);

export const LoadLastMessageFailure = createAction(
    '[Support] Load Last Message Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const SetNextPage = createAction(
    '[Support] Set Next Page',
    props<{ payload: { ticketId: string } }>()
);

export const OpenMessages = createAction(
    '[Support] Open Messages',
    props<{ payload: { ticketId: string } }>()
);


export const SendMessage = createAction(
    '[Support] Send Message',
    props<{ payload: { ticketId: string, request: SupportTicketMessageRequest } }>()
);

export const SendMessageSuccess = createAction(
    '[Support] Send Message Success',
    props<{ payload: { ticketId: string, message: SupportTicketMobileMessageModel } }>()
);

export const SendMessageFailure = createAction(
    '[Support] Send Message Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const AddMessagesWS = createAction(
    '[Support] Add Messages WS',
    props<{ payload: { ticketId: string } }>()
);

export const UpsertTicketWS = createAction(
    '[Support] Upsert Ticket',
    props<{ payload: { response: SupportTicketMobileModel } }>()
);


export const CloseTicket = createAction(
    '[Support] Close Ticket',
    props<{ payload: { ticketId: string } }>()
);

export const CloseTicketSuccess = createAction(
    '[Support] Close Ticket Success',
    props<{ payload: { ticketId: string, response: SupportTicketMobileModel } }>()
);

export const CloseTicketFailure = createAction(
    '[Support] Close Ticket Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const ReopenTicket = createAction(
    '[Support] Reopen Ticket',
    props<{ payload: { ticketId: string, request: SupportTicketMessageRequest } }>()
);

export const ReopenTicketSuccess = createAction(
    '[Support] Reopen Ticket Success',
    props<{ payload: { response: SupportTicketMobileModel } }>()
);

export const ReopenTicketFailure = createAction(
    '[Support] Reopen Ticket Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const CreateTicket = createAction(
    '[Support] Create Ticket',
    props<{ payload: { request: SupportTicketRequest, currentCabinetType: CabinetType } }>()
);

export const CreateTicketSuccess = createAction(
    '[Support] Create Ticket Success',
    props<{ payload: { response: SupportTicketMobileModel } }>()
);

export const CreateTicketFailure = createAction(
    '[Support] Create Ticket Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const SetRating = createAction(
    '[Support] Set Rating',
    props<{ payload: { ticketId: string, rating: number } }>()
);

export const SetRatingSuccess = createAction(
    '[Support] Set Rating Success',
    props<{ payload: { ticketId: string, rating: number } }>()
);

export const SetRatingFailure = createAction(
    '[Support] Set Rating Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const DeleteTicketSuccess = createAction(
    '[Support] Delete Ticket Success',
    props<{ payload: { ticketId: string } }>()
);


export const MarkTicketAsRead = createAction(
    '[Support] Mark Ticket As Read',
    props<{ payload: { ticketId: string } }>()
);

export const MarkTicketAsReadSuccess = createAction(
    '[Support] Mark Ticket As Read Success',
    props<{ payload: { ticketId: string } }>()
);

export const MarkTicketAsReadFailure = createAction(
    '[Support] Mark Ticket As Read Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);
